import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';

export const RequireAdmin = () => {
  const token = useAuthStore((s) => s.accessToken);
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
};
